import * as React from 'react'
import { Banner } from '../../legacy-design-system/banner'
import { css } from '@emotion/css'
import { useStateWithLocalStorage } from '../../hooks/state-with-local-storage'
import { Button } from '@contrast-security-inc/design-system-buttons'

const bannerCss = css`
  margin-right: 24px;
`

const linkCss = css`
  cursor: pointer;
`

export function CookieBanner() {
  const [cookiesAccepted, setCookiesAccepted] = useStateWithLocalStorage(
    'cookiesAccepted',
    false
  )

  return (
    <React.Fragment>
      {!cookiesAccepted && (
        <Banner>
          <div className={bannerCss}>
            Your company has agreed to a{' '}
            <a
              className={linkCss}
              href="https://www.contrastsecurity.com/privacy-matters"
              target="_blank"
              rel="noopener"
            >
              Privacy Policy
            </a>{' '}
            that includes Contrast’s use of cookies. For more information,
            please contact your Privacy Officer.
          </div>
          <Button onClick={() => setCookiesAccepted(true)}>Accept</Button>
        </Banner>
      )}
    </React.Fragment>
  )
}
